export const WORKSPACE_ASIDE_SLOT_ID = "workspace-aside-slot";
